module.exports = __webpack_public_path__ + "assets/static/png/mobsec1_a.04257705f01d4e6f25d3a65fa944cc6f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/mobsec1_a.png
 ** module id = 496
 ** module chunks = 1
 **/